import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Container, Image, HeaderTitle, SubHeaderTitle, ContainerHeader, SubContainerButton, SubContainerField, ContainerImage, ContainerFieldLocation, ContainerSelect, ContainerContent} from './style'
import { MultiSelect } from '../../components/MultiSelect/MultiSelect'
import Input from '../../components/Input/Input'
import InputPassword from '../../components/InputPassword/InputPassword'
import Button from '../../components/Button/Button'
import logo from '../../assets/images/logo.png'
import disableBrowserBackButton from 'disable-browser-back-navigation'
import ModalAlert from '../../components/ModalAlert/ModalAlert'
import { checkGeolocation } from '../../helpers/geo'
import CurrentTime from '../../components/CurrentTime/CurrentTime'
import { fetchLoginAdmStart }  from '../../services/store/reducers/endpoints/loginAdm'
import { fetchCompaniesStart }  from '../../services/store/reducers/endpoints/companies'
import { tokenReset, tokenSave }  from '../../services/store/reducers/token'
import { registerPointSave }  from '../../services/store/reducers/registerPoint'
import { fetchRegistrarInfoStart } from '../../services/store/reducers/endpoints/registrarinfo'

class LoginAdm extends PureComponent{
  
  state = {
    re: '',
    senha: '',
    senhaReadOnly: true,
    sended: false,
    company: 0,
  }

  constructor(props) {
    super(props);
    this.confirmarSenhaInput = React.createRef()
  }

  UNSAFE_componentWillMount () { 
    console.log('----------->', this.props.configuration)
    disableBrowserBackButton()
    this.props.fetchCompaniesStart() 
  }

  continuar = () => {
    if(this.isCamposValidos()) {
      let configuration = {
        ...this.props.configuration,
        re: this.state.re,
        senha: this.state.senha
      }


      //internet
      if (!window.navigator.onLine) {
        window.location.href='/report-user?message=-&errorCode=1'
        return
      }
      
      //location
      checkGeolocation().then((result) => {
        if(result){
          this.setState({
            sended: true
          })
          //const { configuration } = this.props
          console.log(JSON.stringify({
            "Coordenadas": {
              "CodEmpresa": configuration.company.value,
              "CodCliente": configuration.client.value,
              "CodUnidade": configuration.unit.value,
              "Latitude": configuration.lat,
              "Longitude": configuration.lng,
              "Tolerancia": configuration.raio,
            },
            "Login": {
              "Login": this.state.re,
              "Password": this.state.senha,
              "Empresa": configuration.company.value,
            }
          }))
          this.props.fetchLoginAdmStart({
            "Coordenadas": {
              "CodEmpresa": configuration.company.value,
              "CodCliente": configuration.client.value,
              "CodUnidade": configuration.unit.value,
              "Latitude": configuration.lat,
              "Longitude": configuration.lng,
              "Tolerancia": configuration.raio,
            },
            "Login": {
              "Login": this.state.re,
              "Password": this.state.senha, 
              "Empresa": this.state.company,
            }
          })
        }else{
          this.props.fetchRegistrarInfoStart({          
            "RE": this.state.re,
            "Empresa": configuration.company.value,
            "Cliente": configuration.client.value,
            "Unidade": configuration.unit.value,
            "Detalhes": "Usuário não está com GPS habilitado."
          })
          window.location.href='/report-user?message=Você não esta com gps&errorCode=2'
        }
      })
    }
  }

  isCamposValidos() {
    if (!this.state.re) {
      this.setState({titleModal: 'Atenção!', messageModal: 'RE não informado.'})
      return false
    }

    if (this.state.senha.length < this.props.appConfig.tamanhoMinimoSenha) {
        this.setState({
            titleModal: 'Atenção!',
            messageModal: `A senha deve conter no mínimo ${this.props.appConfig.tamanhoMinimoSenha} caracteres.`,
        });
        return false;
    }
    if (this.state.senha.length > this.props.appConfig.tamanhoMaximoSenha) {
        this.setState({ 
            titleModal: 'Atenção!',
            messageModal: `A senha deve conter no máximo ${this.props.appConfig.tamanhoMaximoSenha} caracteres.`,
        });
        return false;
    }


    return true
  }

  respostaLogin = () => {
    
    let resposta = this.props.sagaLoginAdm
    
    if(resposta.token) {

      this.props.tokenSave({ token: resposta.token})

      this.props.registerPointSave({
        re: this.state.re,
            
        codCliente: '',
        codUnidade: '',
        name: '',
        nomeCliente: '',
        nomeUnidade: '',

        horarioEntrada: '',
        horarioSaida: '',
        trocarSenha:  '',
        tipo:  '',
      })

      if(resposta.trocarSenha) {
        this.setState({titleModal: 'Atenção!', messageModal: 'Configurações salvas com sucesso. Você ainda está com sua senha inicial, é necessário que a altere.'})
        //window.location.href = '/update-password?routeBack=home'
      }else{
        this.setState({titleModal: 'Atenção!', messageModal: resposta.mensagem})
        //window.location.href = '/home'
      }
    }else{
      this.setState({titleModal: 'Atenção!', messageModal: resposta.mensagem == null ? 'Usuário não encontrado' : resposta.mensagem})
    }
    this.setState({
      sended: false
    })
  }

  voltar = () => {
    if (!window.navigator.onLine) {
      window.location.href='/report-user?message=-&errorCode=1'
      return
    }
    window.location.href = '/configuration'
  }

  handleKeyPressSenha = (event) => {
    
    if(event.key === 'Enter'){
      this.confirmarSenhaInput.current.focus();
    }
  }

  handleKeyPressConfirmarSenha = (event) => {
    
    if(event.key === 'Enter'){
      this.continuar()
    }
  }
 
  render() {
    
    const { sagaLoginAdm, sagaCompanies } = this.props
    return (
      <Container>
        <ContainerImage>
          <Image src={logo} />
        </ContainerImage>
         <CurrentTime></CurrentTime> 
        <ContainerHeader>
            <HeaderTitle>Login</HeaderTitle>
            <SubHeaderTitle>Digite um usuário com permissão para alterar as configurações de unidade</SubHeaderTitle>
          </ContainerHeader>

        <ContainerContent>
        <ContainerFieldLocation>
          <SubContainerField>
            { /* para funcionar maxlength em type number é necessário utilizar  substr*/}
              <Input type='number' 

              onChange={ (event) => { 
                this.setState({re: event.target.value.substr(0, 6)})
              }}
              value={this.state.re}
              onKeyPress={(event) => { this.handleKeyPressSenha(event)}}
              placeholder='RE/Matrícula' autocomplete='off' />
          </SubContainerField>
          </ContainerFieldLocation>
          
          {
            !this.state.habilitado &&
            
            <ContainerSelect>
            
            <MultiSelect   options={ !sagaCompanies ? [] : sagaCompanies.map((val) => {
              return {
                value: val.codigoEmpresaSAR,
                label: val.nome
              }
            }) } onChange={(event) => {this.setState({company: event.value})}}
            placeholder= {'Selecione empresa'}
            />
          </ContainerSelect>
          }
          <ContainerFieldLocation>
          
          <SubContainerField>
            <InputPassword type='text'
            autoComplete={"off"} 
            readOnly={ this.state.senhaReadOnly }
            onFocus={ this.setState({senhaReadOnly: false}) }
            ref={this.confirmarSenhaInput}
            onKeyPress={(event) => { this.handleKeyPressConfirmarSenha(event)}}
            onChange={ (event) => { 
              this.setState({senha: event.target.value}) 
            }}value={this.state.senha}
            placeholder='Senha' />
          </SubContainerField>
          </ContainerFieldLocation>

        </ContainerContent>
        <SubContainerButton>
          <Button width='130px' backgroundColor='#40bbca' onClick={() => { this.voltar() }}>Voltar</Button>
          <Button width='130px'  backgroundColor='#40bbca' onClick={() => { this.continuar() }}>Continuar</Button>
        </SubContainerButton>

        {
          sagaLoginAdm &&
          this.state.sended &&
          this.respostaLogin()
        }
        {
          //para colocar os pop up
          this.state.titleModal && 
          this.state.messageModal &&
          this.state.titleModal.length > 0 &&
          this.state.messageModal.length > 0 &&
          <ModalAlert 
            title={this.state.titleModal} 
            message={ this.state.messageModal} 
            onClick={() => { 
              this.setState({messageModal: '', titleModal: ''}) 

              if(
                sagaLoginAdm.token
                && sagaLoginAdm.trocarSenha
              ) {
                window.location.href = '/update-password?routeBack=home'
                return
              }

              if(
                sagaLoginAdm.token
                && !sagaLoginAdm.trocarSenha
              ) {
                window.location.href = '/home'
                return
              }

            } }
            />
        }  
     </Container>
    )
  }
}
const mapStateToProps = state => ({
  configuration: state.configuration,
  sagaLoginAdm: state.sagaLoginAdm.data,
  sagaCompanies: state.sagaCompanies.data,
  appConfig: state.appConfig,
})

const mapDispatchToProps = dispatch => ({
  fetchRegistrarInfoStart: (value) => dispatch(fetchRegistrarInfoStart(value)),
  registerPointSave: (value) => dispatch(registerPointSave(value)),
  fetchLoginAdmStart: (mss) => dispatch(fetchLoginAdmStart(mss)),
  tokenReset: () => dispatch(tokenReset()),
  tokenSave: (value) => dispatch(tokenSave(value)),
  fetchCompaniesStart: (mss) => dispatch(fetchCompaniesStart(mss)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginAdm)